import CRUDServiceOperations from "./CRUDServiceOperations";
class DocumentService extends CRUDServiceOperations {
  downloadDocument(url, failureCallback) {
    return this.download(url, failureCallback);
  }

  postDocument(document, file, callback, failureCallback) {
    const data = this.bodyFactory.createMultipartBody(file, "file", {
      documentInfo: document
    });
    const url = this.getEntitiesUrl();
    return this.post(
      url,
      data,
      callback,
      undefined,
      failureCallback,
      false,
      null
    );
  }

  getEntitiesUrl = () => {
    return this.urlFactory.documentsUrl();
  };
}
export default DocumentService;
